import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import { AppProvider } from "@/store";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import LegalPage from "@/pages/LegalPage";
import NewsPage from "@/pages/NewsPage";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/mentions-legales" element={<LegalPage />} />
          <Route path="/actualites" element={<NewsPage />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
